import { jsonParse } from "common/helpers/serialization"
import { getValidJsonString } from "common/helpers/string"
import type { AbiInputWithValue } from "createProposal/types/abi"

type AbiEncodeArgs = {
  types: string[]
  values: string[]
}

export const getInputTypesAndValues = (
  inputs: AbiInputWithValue[],
): AbiEncodeArgs => {
  return inputs.reduce(
    (result, { type, value }) => {
      const nextTypes = [...result.types, type]

      if (type === "tuple" || type.endsWith("[]")) {
        return {
          types: nextTypes,
          values: [...result.values, jsonParse(getValidJsonString(value))],
        }
      }

      if (type === "bool") {
        const nextValue =
          value.toLocaleLowerCase() === "false" || value === "0" ? false : true

        return {
          types: nextTypes,
          values: [...result.values, nextValue],
        }
      }

      return {
        types: nextTypes,
        values: [...result.values, value],
      }
    },
    { types: [], values: [] } as AbiEncodeArgs,
  )
}
